import {Component, h} from 'preact';
import throttleToFrame from '~/utils/events/throttleToFrame';
import TableHeadRow from './TableHeadRow';

/**
 * Component Properties.
 */
interface TableHeadProps
{
	[key: string]: void;
}

/**
 * Component State.
 */
interface TableHeadState
{
	[key: string]: void;
}

/**
 * Шапка таблицы планировок.
 */
class TableHead extends Component<TableHeadProps, TableHeadState>
{
	/**
	 * Основная строка шапки.
	 */
	private rowMain: HTMLTableRowElement | null;
	/**
	 * Строка-клон для закрепления.
	 */
	private rowFixed: HTMLTableRowElement | null;
	
	/**
	 * Шапка таблицы планировок.
	 */
	public constructor( props: TableHeadProps )
	{
		super( props );
		
		this.onWindowResize = throttleToFrame( this.onWindowResize );
	}
	
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		window.addEventListener( 'resize', this.onWindowResize );
		this.onWindowResize();
	}
	
	/**
	 * Before component will be unmounted and destroyed.
	 */
	public componentWillUnmount(): void
	{
		window.removeEventListener( 'resize', this.onWindowResize );
	}
	
	/**
	 * Before render, return false to skip render.
	 */
	public shouldComponentUpdate(): boolean
	{
		// Никогда не обновлять компонент.
		return false;
	}
	
	/**
	 * Render component.
	 */
	public render(): JSX.Element
	{
		return (
			<thead>
				<TableHeadRow
					className="main"
					elementRef={this.refRowMain}
				/>
				<TableHeadRow
					className="fixed"
					role="presentation"
					elementRef={this.refRowFixed}
				/>
			</thead>
		);
	}
	
	/**
	 * Сохраняет ссылку на элемент основной строки шапки.
	 */
	private refRowMain = ( element: HTMLTableRowElement ): void =>
	{
		this.rowMain = element;
	}
	
	/**
	 * Сохраняет ссылку на элемент строки для закрепления.
	 */
	private refRowFixed = ( element: HTMLTableRowElement ): void =>
	{
		this.rowFixed = element;
	}
	
	/**
	 * Изменяет размер ячеек фиксированной строки при изменении размера окна.
	 */
	private onWindowResize = (): void =>
	{
		if ( !this.rowMain || !this.rowFixed )
		{
			return;
		}
		
		for ( let i = 0, n = this.rowMain.cells.length; i < n; i++ )
		{
			const mainTr = this.rowMain.cells[i];
			const fixedTr = this.rowFixed.cells[i];
			
			fixedTr.style.width = window.getComputedStyle( mainTr ).width;
		}
	}
}

/**
 * Module.
 */
export {
	TableHead as default,
	TableHeadProps,
	TableHeadState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/TableHead.tsx